import { createStore } from 'vuex'
import { event as gtagEvent } from 'vue-gtag';

export default createStore({
  state: {
    analyticsToolName: "Shafting Special Machining",
    host: window.thomsonSettings & window.thomsonSettings.name ? window.thomsonSettings.name : "Thomson"
  },
  mutations: {
  },
  actions: {

    trackEvent(context, { action, label = null, value = null }) {


      // Define standard event name
      let eventName = "widget_shafting_machining"

      if (process.env.VUE_APP_TYPE === "distributor") {

        // Google Analytics (GA4) tracking for distributor sites only.

        let eventDetails = {
          action: action,
          description: label,
          value: value,
          product_line: "shafting",
          origin: window.location.pathname,
          distributor: context.state.host
        }
        if (process.env.VUE_APP_TRACKING_ENABLED == 'true') {
          gtagEvent(eventName, eventDetails);
        } else {
          // eslint-disable-next-line
          console.log(`%c${eventName}:`, "background:#41b883; padding:1px 3px; border-radius:3px; color:#fff", eventDetails);
        }

      } else {

        // Google Analytics 4 (GA4) tracking for Thomson sites only.
        // Since it will be integrated with the TLO config/property instead of being separate, the only thing we need is access to the global dataLayer[]. 
        // Each event is pushed into the dataLayer, and then Google Tag Manager picks it up and pushes it to Google Analytics. 

        let event = {
          event: eventName,
          action: action,
          description: label,
          value: value,
          product_line: "shafting",
          origin: window.location.pathname
        }

        // Submit to dataLayer
        if (process.env.VUE_APP_TRACKING_ENABLED == "true") {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(event)
        } else {
          // eslint-disable-next-line
          console.log(`%c${eventName}`, "background:#75308a; padding:1px 3px; border-radius:3px; color:#fff", event);
        }

      }
      
    },

  },
  modules: {
  }
})
